import moment from 'moment';
import React, { Component } from 'react';
import { customFetchV2 } from '../../../services/custom-fetch-v2.ts';
import Loading from '../Loading.jsx';

class DeviceCallLogRoute extends Component {
  state = {
    isLoading: true,
    calls: [],
  };

  componentDidMount() {
    this.loadCalls();
  }

  loadCalls() {
    const deviceId = this.props.match.params.id;

    this.setState({
      isLoading: true,
    });

    customFetchV2(`/api/devices/${deviceId}/calls`, {
      method: 'GET',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Ooops');
        }

        return response.data;
      })
      .then((json) => {
        this.setState({
          isLoading: false,
          calls: json,
        });
      })
      .catch((error) => {
        this.setState({
          errorMsg: error.message,
          isLoading: false,
        });
      });
  }

  renderCallLogRows = calls => calls.map((call, ix) => (
    <AudioCallLogRow key={ix} call={call}/>
  ));

  renderContent() {
    if (this.state.isLoading) {
      return <Loading/>;
    }

    return (
      <table className="table is-striped is-hoverable is-fullwidth">
        <thead>
          <tr>
            <th>Time</th>
            <th>From</th>
            <th>Duration</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {this.renderCallLogRows(this.state.calls)}
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <div className="section">
        {this.renderContent()}
      </div>
    );
  }
}

function AudioCallLogRow(props) {
  const {
    timestamp, fromFormatted, duration, status,
  } = props.call;

  const timestampFormatted = moment(timestamp).local().format('YYYY-MM-DD @ HH:mm:ss');
  const durationMins = Math.ceil(duration / 60);
  const durationFormatted = `${durationMins} ${durationMins > 1 ? 'mins' : 'min'}`;

  return (
    <tr>
      <td>{timestampFormatted}</td>
      <td>{fromFormatted}</td>
      <td>{durationFormatted}</td>
      <td><AudioCallStatusTag status={status} /></td>
    </tr>
  );
}

function AudioCallStatusTag(props) {
  const { status } = props;
  const statusFormatted = status.charAt(0).toUpperCase()
    + status.slice(1).toLowerCase();

  const classNames = ['tag', 'is-small'];
  if (statusFormatted === 'Completed') {
    classNames.push('is-success');
  }

  return <span className={classNames.join(' ')}>{statusFormatted}</span>;
}

export default DeviceCallLogRoute;
